import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { css } from 'emotion';
import s from './TableRow.styles';
import Svg from '../Svg';
import TableCell from '../TableCell';

const draggableRowStyle = css`
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  .drag-handle {
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
    transition: opacity 0.2s;
  }

  &:hover .drag-handle {
    opacity: 1;
  }
`;

const draggingStyle = css`
  opacity: 0.5;
`;

export class TableRow extends React.Component {
  handleDragStart = () => {
    const { onDragStart, rowIndex } = this.props;
    if (onDragStart) {
      onDragStart(rowIndex);
    }
  };

  handleDragOver = e => {
    const { onDragOver } = this.props;
    if (onDragOver) {
      onDragOver(e);
    }
  };

  handleDrop = () => {
    const { onDrop, rowIndex } = this.props;
    if (onDrop) {
      onDrop(rowIndex);
    }
  };

  handleDragEnd = () => {
    const { onDragEnd } = this.props;
    if (onDragEnd) {
      onDragEnd();
    }
  };

  render() {
    const {
      headings,
      htmlTableCells,
      name,
      row,
      rowIndex,
      draggable,
      isDragging,
    } = this.props;

    // Make sure we don't create more body cells than heading cells
    const text = row.text.slice(0, headings ? headings.length : 0);
    const dataAttributes = row.dataAttributes
      ? {
          ...row.dataAttributes,
        }
      : {};

    return (
      <tr
        className={cx(
          s,
          row.onRowClick ? 'clickable' : '',
          draggable ? draggableRowStyle : '',
          isDragging ? draggingStyle : '',
        )}
        data-index={rowIndex}
        data-name={name}
        onClick={row.onRowClick}
        data-test={`narvar-table-row-${rowIndex}`}
        draggable={draggable}
        onDragStart={this.handleDragStart}
        onDragOver={this.handleDragOver}
        onDrop={this.handleDrop}
        onDragEnd={this.handleDragEnd}
        {...dataAttributes}
      >
        {draggable && (
          <td
            className="drag-handle-cell"
            style={{ width: '40px', padding: '0' }}
          >
            <div className="drag-handle" style={{ padding: 0, margin: 0 }}>
              <Svg name="menu" width={14} height={14} />
            </div>
          </td>
        )}
        {text.map((data, dataIndex) => (
          <TableCell
            data={data}
            dataIndex={dataIndex}
            key={dataIndex}
            width={headings[dataIndex].width}
            isHtml={
              htmlTableCells !== undefined
                ? htmlTableCells[dataIndex]
                : undefined
            }
          />
        ))}
      </tr>
    );
  }
}

TableRow.propTypes = {
  headings: PropTypes.array,
  htmlTableCells: PropTypes.array,
  name: PropTypes.string,
  row: PropTypes.object,
  rowIndex: PropTypes.number,
  isHtml: PropTypes.bool,
  draggable: PropTypes.bool,
  onDragStart: PropTypes.func,
  onDragOver: PropTypes.func,
  onDrop: PropTypes.func,
  onDragEnd: PropTypes.func,
  isDragging: PropTypes.bool,
};

export default TableRow;
